<h1>404</h1>
Seite nicht gefunden<br>
<button type="button" class="btn btn-info mr-3" (click)="start()">Zur Startseite</button>
